import {create} from 'zustand';
import {expenseCategoryApi} from '../services/api/expenseCategoryApi';

export const useExpenseCategoryStore = create((set) => ({
  expenseCategories: [],
  isLoading: false,

  fetchExpenseCategories: async () => {
    set({isLoading: true});
    try {
      const response = await expenseCategoryApi.list();
      set({expenseCategories: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },

  createExpenseCategory: async (data) => {
    const response = await expenseCategoryApi.create(data);
    const newItem = response.data.data;
    set(state => ({expenseCategories: [...state.expenseCategories, newItem]}));
    return newItem;
  },

  updateExpenseCategory: async (id, data) => {
    const response = await expenseCategoryApi.update(id, data);
    const updated = response.data.data;
    set(state => ({
      expenseCategories: state.expenseCategories.map(c => (c.id === id ? updated : c)),
    }));
    return updated;
  },

  deleteExpenseCategory: async (id) => {
    await expenseCategoryApi.remove(id);
    set(state => ({
      expenseCategories: state.expenseCategories.filter(c => c.id !== id),
    }));
  },
}));
